export default __webpack_public_path__ + "static/media/spoon.d079f43f.svg";